(function() {
    // ============================================================
    // 1. 基本元素与参数定义
    // ============================================================
    // 需要进行打字动画的完整文本
    const fullText = 'キーワードや用途から記事を検索';
    // 用于显示打字文字的 span 元素（占位提示层）
    const typingEl = document.getElementById('typing-placeholder');
    // 实际的搜索输入框
    const searchInput = document.getElementById('search-input');

    // 动画状态变量
    let index = 0;           // 当前已经显示到第几个字符（从 0 开始）
    let isDeleting = false;  // 是否处于“删除”阶段（false 表示正在打字，true 表示正在删除）
    let timeoutId = null;    // 用于保存 setTimeout 的返回值，方便取消

    // 动画速度参数（单位：毫秒）
    const TYPE_SPEED = 120;           // 每个字符打出来的间隔
    const DELETE_SPEED = 70;          // 每个字符删除的间隔
    const PAUSE_BEFORE_DELETE = 1800; // 全部打完后，停留多久再开始删除
    const PAUSE_BEFORE_TYPE = 500;    // 全部删除后，停留多久再重新开始打字

    // ============================================================
    // 2. 核心动画更新函数
    // ============================================================
    function updateTyping() {
        // 根据当前 index，截取要显示的文字
        const currentText = fullText.substring(0, index);
        typingEl.textContent = currentText;

        if (!isDeleting) {
            // ---------- 打字阶段 ----------
            if (index < fullText.length) {
                // 还没打完，继续增加字符
                index++;
                timeoutId = setTimeout(updateTyping, TYPE_SPEED);
            } else {
                // 全部打完了 → 进入删除阶段，先等待一段时间
                isDeleting = true;
                timeoutId = setTimeout(updateTyping, PAUSE_BEFORE_DELETE);
            }
        } else {
            // ---------- 删除阶段 ----------
            if (index > 0) {
                // 还有字符可删，减少一个字符
                index--;
                timeoutId = setTimeout(updateTyping, DELETE_SPEED);
            } else {
                // 全部删完了 → 回到打字阶段，先等待一段时间
                isDeleting = false;
                timeoutId = setTimeout(updateTyping, PAUSE_BEFORE_TYPE);
            }
        }
    }

    // ============================================================
    // 3. 输入框交互处理
    // ============================================================
    // 当输入框获得焦点时：如果输入框为空，隐藏打字动画（避免干扰用户输入）
    function handleFocus() {
        if (searchInput.value.trim() === '') {
            typingEl.style.display = 'none';
        }
    }

    // 当输入框失去焦点时：如果输入框为空，重新显示打字动画并恢复动画
    function handleBlur() {
        if (searchInput.value.trim() === '') {
            typingEl.style.display = 'block';

            // 清除可能还在运行的定时器，避免多个动画同时执行
            if (timeoutId) {
                clearTimeout(timeoutId);
            }

            // 注意：这里保持当前的 index 和 isDeleting 状态继续动画，
            // 而不是从头开始，这样动画看起来更自然。
            // 如果希望每次失焦都从头开始，可以取消下面几行的注释：
            // index = 0;
            // isDeleting = false;
            // typingEl.textContent = '';

            updateTyping(); // 继续动画
        }
    }

    // 监听输入事件：用户开始输入时立即隐藏打字动画；清空输入框时根据焦点状态决定是否恢复
    searchInput.addEventListener('input', function() {
        if (searchInput.value.trim() !== '') {
            // 有内容时，隐藏打字动画
            typingEl.style.display = 'none';
        } else {
            // 内容被清空时：
            // 如果当前仍处于聚焦状态，保持隐藏（因为 handleFocus 已经隐藏了）
            // 否则恢复显示
            if (document.activeElement === searchInput) {
                typingEl.style.display = 'none';
            } else {
                typingEl.style.display = 'block';
            }
        }
    });

    // 绑定焦点事件
    searchInput.addEventListener('focus', handleFocus);
    searchInput.addEventListener('blur', handleBlur);

    // ============================================================
    // 4. 页面初始化
    // ============================================================
    // 如果输入框中已经有值（例如通过 Shopify 模板渲染的 search.terms），则不要启动动画
    if (searchInput.value.trim() !== '') {
        typingEl.style.display = 'none'; // 直接隐藏打字动画层
    } else {
        // 输入框为空时，启动打字动画
        typingEl.style.display = 'block';

        // 重置状态，确保从头开始
        index = 0;
        isDeleting = false;
        typingEl.textContent = '';

        // 延迟 400 毫秒开始，避免页面加载瞬间的闪烁
        timeoutId = setTimeout(updateTyping, 400);
    }

    // ============================================================
    // 5. 清理工作
    // ============================================================
    // 页面即将卸载时，清除定时器，避免资源浪费
    window.addEventListener('beforeunload', function() {
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
    });

    // 表单提交时也清除定时器（防止提交后动画还在后台运行）
    document.getElementById('search-form')?.addEventListener('submit', function() {
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
    });
})();